<template>
    <div class="flex flex-row border-t border-b border-l">
        <div v-for="(step, index) of steps.filter(({ show }) => show != false)" :key="step.name" @click="$router.push({ name: step.route })" class="p-2 border-r w-full flex flex-row justify-center cursor-pointer select-none" :class="$route.name == step.route ? 'bg-white' : isStepDone(step) ? 'bg-green-100' : ''">
            <div class="flex flex-row items-center justify-center text-center rounded-full h-6 w-6 text-sm font-bold" :class="$route.name == step.route ? 'bg-primary text-white' : isStepDone(step) ? '' : 'border text-gray-500'">
                <div v-if="isStepDone(step)">
                    <div class="h-2 w-4 border-b-2 border-l-2 border-green-500" :style="{ transform: 'translateY(-.125rem)rotate(-45deg)' }"></div>
                </div>
                <div v-else>
                    {{ index + 1 }}
                </div>
            </div>
            <div class="ml-4 font-bold" :class="$router.name == step.route ? 'text-black' : isStepDone(step) ? 'text-green-500' : 'text-gray-600'">
                {{ $t(`steps[${index}]`) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: vue => ({
        steps: [
            { route: 'configure' },
            { route: 'informations' },
            { route: 'done', show: false },
        ],
    }),
    methods: {
        isStepDone(step) {
            return this.steps.indexOf(this.steps.find(({ route }) => this.$route.name == route )) > this.steps.indexOf(step)
        }
    }
}
</script>